import { Box, Button, Input, Select } from "@chakra-ui/react";
import { ReactNode } from "react";
import { MdDelete } from "react-icons/md";
import { THEME_COLOR_SCHEME } from "../utils/theme";

interface PropertyFormProps {
  properties: { [name: string]: string };
  setProperties: React.Dispatch<
    React.SetStateAction<{ [name: string]: string }>
  >;
  propertyOptions?: string[];
  buttonText?: ReactNode;
}

export const PropertyForm = ({
  properties,
  setProperties,
  propertyOptions,
  buttonText,
}: PropertyFormProps) => {
  return (
    <Box paddingTop={2}>
      <Button
        colorScheme={THEME_COLOR_SCHEME}
        variant={"outline"}
        width={"100%"}
        onClick={() => {
          setProperties((p) => ({
            ...p,
            "": "",
          }));
        }}
      >
        {buttonText ?? "Add Property"}
      </Button>
      {Object.entries(properties).map(([name, value], i) => (
        <Box key={i} width={"100%"} display={"flex"} marginTop={2}>
          {propertyOptions ? (
            <Select
              placeholder="Name"
              marginRight={2}
              value={name}
              onChange={(e) =>
                setProperties((p) =>
                  Object.fromEntries(
                    Object.entries(p).map(([k, v], j) =>
                      j === i ? [e.target.value, v] : [k, v]
                    )
                  )
                )
              }
            >
              {propertyOptions.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </Select>
          ) : (
            <Input
              placeholder="Name"
              marginRight={2}
              value={name}
              onChange={(e) =>
                setProperties((p) =>
                  Object.fromEntries(
                    Object.entries(p).map(([k, v], j) =>
                      j === i ? [e.target.value, v] : [k, v]
                    )
                  )
                )
              }
            />
          )}
          <Input
            placeholder="Value"
            marginRight={2}
            value={value}
            onChange={(e) =>
              setProperties((p) =>
                Object.fromEntries(
                  Object.entries(p).map(([k, v], j) =>
                    j === i ? [k, e.target.value] : [k, v]
                  )
                )
              )
            }
          />
          <Button
            color={"red.500"}
            onClick={() =>
              setProperties((p) =>
                Object.fromEntries(Object.entries(p).filter((_, j) => j !== i))
              )
            }
          >
            <MdDelete size={30} />
          </Button>
        </Box>
      ))}
    </Box>
  );
};
